import { Box, SxProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CONTRACT_RENEWAL_STEPS, ContractRenewalStatusDto, ContractRenewalStep } from 'domain/shared/newProject';
import { Button } from 'framework/ui/mui-builder';
import { ONE_STOP_PATH } from 'domain/shared/oneStop';
import { OPPORTUNITY_PATH } from 'domain/shared/core/sharedRouteConstants';

type ContractRenewalActionProject = {
  accountData?: {
    accountId?: string | number;
  };
  legacyId?: number;
};

interface ContractRenewalActionsProps {
  renewalStatus: ContractRenewalStatusDto | null;
  onConfirm: () => void;
  project?: ContractRenewalActionProject;
  sxProps?: SxProps;
}

const ContractRenewalActions = ({ renewalStatus, onConfirm, project, sxProps }: ContractRenewalActionsProps) => {
  const navigate = useNavigate();
  if (!renewalStatus || renewalStatus.step === CONTRACT_RENEWAL_STEPS.NO_ACTION_REQUIRED) {
    return null;
  }

  const actionButtonConfig: Record<
    Exclude<ContractRenewalStep, typeof CONTRACT_RENEWAL_STEPS.NO_ACTION_REQUIRED>,
    { label: string; onClick: () => void }
  > = {
    [CONTRACT_RENEWAL_STEPS.CREATE_OPPORTUNITY]: {
      label: 'Create opportunity',
      onClick: () =>
        navigate(
          `${OPPORTUNITY_PATH}/add?accountId=${project?.accountData?.accountId}&isContractRenewal=yes&relatedProjectId=${project?.legacyId}`,
        ),
    },
    [CONTRACT_RENEWAL_STEPS.SEND_PRESALE_REQUEST]: {
      label: 'Send presale request',
      onClick: () => navigate(`${OPPORTUNITY_PATH}/${renewalStatus.opportunityId}/activities`),
    },
    [CONTRACT_RENEWAL_STEPS.INITIATE_WITHOUT_SOW]: {
      label: 'Initiate project without SOW',
      onClick: () => navigate(`${ONE_STOP_PATH}/PM03?opportunityId=${renewalStatus.opportunityId}&projectRenewal`),
    },
  };

  const actionConfig = actionButtonConfig[renewalStatus.step];

  return (
    <Box gap={1} display="flex" sx={sxProps}>
      {actionConfig && (
        <Button variant="contained" onClick={actionConfig.onClick}>
          {actionConfig.label}
        </Button>
      )}
      <Button variant="outlined" onClick={onConfirm}>
        Confirm non-renewal
      </Button>
    </Box>
  );
};

export default ContractRenewalActions;
